module.exports = __webpack_public_path__ + "static/media/europe-electricity.759bbde6.png";